import React, {useEffect, useState} from 'react';
import './displayModal.css';
import DropDown from '../../components/common/Select/select';
import TextField from '../../components/common/TextField/TextField';
import Image from '../../components/common/ImageBox/image';
import KeyVal from '../../components/common/keyValDisplay/keyVal';
import Button from '../../components/common/Button2/button';
import SearchTextBox from '../../components/common/SearchTextBox/searchTextBox';
import FileUpload from '../../components/common/FileUpload/fileUpload';
import RadioButton from '../../components/common/RadioButton/radioButton';
import CheckBox from '../../components/common/Checkbox/checkbox';
import ToggleButton from '../../components/common/Switch/toggleButton';
import TextArea from '../../components/common/TextArea/TextArea';
import MultiSelect from '../../components/common/MultiSelect/multiSelect';
import Table from '../../components/table/table';
import { searchProductData } from '../../api/productsApi';

function DisplayContent({ contentData, formFields, formErrors, handleInputChange, handleButtonClick, source, page }) {
    const dropDownData = sessionStorage.getItem('dropDownData') ? JSON.parse(sessionStorage.getItem('dropDownData')) : {};
    const imageItem = contentData?.find(item => item.field == 'image');
    const [processedForm, setForm] = useState(null)

    const handleChange = (value, key) => {
        handleInputChange(value, key);
    }

    useEffect(() => { 
        const modifyModal = async () => { 
            if(contentData && (page == 'device' || page == 'certificate')){
                if(source?.includes('modal') && !source?.includes('create')){
                    if(formFields?.productId == null){
                        contentData.map((obj) => {
                            obj.disabled = true;
                            obj.editable = false;
                        })
                    }
                    if(formFields?.productId !== null && formFields?.status == 'Inactive'){
                        contentData.map((obj) => {
                            if(obj.name !== 'Status') obj.disabled = true;
                            if(obj.name !== 'Status') obj.editable = false;
                        })
                    }
                }
                if(source?.includes('modal') && source?.includes('create')){
                    formFields['status'] = 'Active'
                }
                setForm(contentData)
            }
            else if(contentData && page == 'Firmware'){ 
                if(source.includes('create')){
                    contentData.map((obj) => {
                        if(obj.key == 'publish') {
                            obj.editable = false;
                            obj.disabled = true;
                        }
                    })
                }
                if(formFields['publish'] == 'Yes'){
                    contentData.map((obj) => {
                        if(obj.key == 'publish') obj.editable = false;
                    })
                }
                if(formFields['publish'] == 'No'){
                    const productStatus = await fetchProductInfo(formFields['productId'])
                    if(productStatus == 'Test'){
                    contentData.map((obj) => {
                        if(obj.key == 'publish') {
                            obj.editable = false;
                            obj.disabled = true;
                        }
                    })
                }
                }
                if(formFields['enableFirmware'] !== 'Enabled' && !source.includes('create')){                
                    contentData.map((obj) => {
                        obj.editable = false;
                        obj.disabled = true;
                    })
                }
                setForm(contentData)
            }
            else{
                setForm(contentData)
            }
        }        
        modifyModal()
    }, [contentData])
    
    useEffect(() => {},[formFields, contentData])

    const handleButtonTrigger = (field) => {
        handleButtonClick(field);
    }

    const fetchProductInfo = async (pid) => {
        const productData = await searchProductData({ 'matterProductId': pid });
        if(productData?.data?.data.length > 0) {
            return(productData?.data?.data[0].status)
        }
    }

    const handleCheckBoxSelect = (e, name) => {
        const checkBoxData = formFields[name].map((option) => {
            if (option.name === e.target.name) {
                return {
                    ...option,
                    checked: e.target.selected,
                };
            } else {
                return option;
            }
        });
        handleChange(checkBoxData, name)
    };

    if(processedForm == null){
        return <div>Loading......</div>
    }

    return (
        <div className={source?.includes('modal') ? 'modal-body-content' : 'sub-nav-content'}>
            {
                imageItem &&
                <div key={imageItem.key} className='ImageBox'>
                    {
                        imageItem.imageUrl ? <Image imageUrl={imageItem.imageUrl}></Image> : null
                    }
                </div>
            }
            <div className='nextImageAlign'>
                {
                    processedForm && source.includes('view') && processedForm.map((obj) => {
                        return (
                            <div key={obj.key} className={source == 'modal' ? 'form-element' : null}>
                                <KeyVal label={obj.name} key1={obj.key} defaultValue={formFields && formFields[obj.key] ? formFields[obj.key] : '-'}></KeyVal>
                            </div>
                        )
                    })
                }
                {
                    processedForm && !source.includes('view') && processedForm.map((obj) => {
                        if (obj.field == 'text') {
                            return (
                                <div key={obj.key} className={source == 'modal' ? 'form-element' : null}>
                                    <KeyVal label={obj.name} key1={obj.key} defaultValue={formFields && formFields[obj.key] ? formFields[obj.key] : '-'}></KeyVal>
                                </div>
                            )
                        }
                        if (obj.field == 'button') {
                            return (
                                <div key={obj.key} className={source == 'modal' ? 'form-element' : null}>
                                    <Button onHandleClick={handleButtonTrigger} label={obj.name} type={obj.type ? obj.type : null} iconName={obj.iconName ? obj.iconName : null} disabled={obj.disabled ? obj.disabled : false}/>
                                </div>
                            )
                        }
                        if (obj.field == 'searchBox') {
                            return (
                                <div key={obj.key} className={source == 'modal' ? 'form-element' : null}>
                                    <SearchTextBox type='text' placeholder={obj.name} onSearch={handleChange}></SearchTextBox>
                                </div>
                            )
                        }
                        if (obj.field == 'input') {
                            return (
                                <div key={obj.key} className={source == 'modal' ? 'form-element' : null}>
                                    <TextField
                                        label={obj.name}
                                        type={obj.type}
                                        step={obj.step? obj.step : null}
                                        action={obj.action ? obj.action : null}
                                        key1={obj.key}
                                        tooltiptext={obj.tooltiptext}
                                        required={obj.required}
                                        readOnly={source?.includes('create') ? obj.disabled : source?.includes('edit') ? !obj.editable : source?.includes('view') ? true : false}
                                        placeholder={`Enter ` + obj.name}
                                        label-align='left'
                                        error={formErrors && formErrors[obj.key] ? formErrors[obj.key] : null}
                                        defaultValue={formFields && formFields[obj.key] ? formFields[obj.key] : null}
                                        onChange={(value) => handleChange(value, obj.key)}>
                                    </TextField>
                                </div>
                            )
                        }
                        if (obj.field == 'textArea') {
                            return (
                                <div key={obj.key} className={source == 'modal' ? 'form-element' : null}>
                                    <TextArea
                                        label={obj.name}
                                        type={obj.type}
                                        required={obj.required}
                                        maxLength={obj.maxLength}
                                        tooltiptext={obj.tooltiptext}
                                        action={obj.action ? obj.action : null}
                                        readOnly={source?.includes('create') ? obj.disabled : source?.includes('edit') ? !obj.editable : source?.includes('view') ? true : false}
                                        placeholder={`Enter ` + obj.name}
                                        label-align='left'
                                        error={formErrors && formErrors[obj.key] ? formErrors[obj.key] : null}
                                        defaultValue={formFields && formFields[obj.key] ? formFields[obj.key] : null}
                                        onChange={(value) => handleChange(value, obj.key)}>
                                    </TextArea>
                                </div>
                            )
                        }

                        if (obj.field == 'dropdown') {
                            return (
                                <div key={obj.key} className={source == 'modal' ? 'form-element' : null}>
                                    <DropDown
                                        label={obj.name}
                                        ddoptionlist={dropDownData[obj.optionList]}
                                        type={obj.key}
                                        required={obj.required}
                                        tooltiptext={obj.tooltiptext}
                                        action={obj.action ? obj.action : null}
                                        disabled={source?.includes('create') ? obj.disabled : source?.includes('edit') ? !obj.editable : source?.includes('view') ? true : false}
                                        placeholder={`Select ` + obj.name}
                                        error={formErrors && formErrors[obj.key] ? formErrors[obj.key] : null}
                                        defaultValue={formFields && formFields[obj.key] ? formFields[obj.key] : null}
                                        onChange={(value) => handleChange(value, obj.key)} />
                                    {/* { obj.separator ? <div className='vl'></div> : null
                                        } */}
                                </div>
                            )
                        }

                        if (obj.field == 'multiSelect') {
                            return (
                                <div key={obj.key} className={source == 'modal' ? 'form-element' : null}>
                                    <MultiSelect
                                        onClick={(value) =>handleChange(value,obj.key)}
                                        data={Array.isArray(obj.optionList) ? obj.optionList : dropDownData[obj.optionList]}
                                        label={obj.name}
                                        type={obj.key}
                                        required={obj.required}
                                        tooltiptext={obj.tooltiptext}
                                        textKey="name"
                                        action={obj.action ? obj.action : null}
                                        disabled={source?.includes('create') ? obj.disabled : source?.includes('edit') ? !obj.editable : source?.includes('view') ? true : false}
                                        selectorKey="name"
                                        searchPlaceholder={`Select ` + obj.name}
                                        error={formErrors && formErrors[obj.key] ? formErrors[obj.key] : null}
                                        placeholder={
                                            formFields && formFields[obj.key]
                                            ? `${formFields[obj.key].length} users selected`
                                            : 'Select users'
                                        }
                                        defaultValue={formFields && formFields[obj.key] ? formFields[obj.key] : null}
                                    />
                                </div>
                            )
                        }

                        if(obj.field?.includes('FileUpload')){
                            return (
                                <div key={obj.key} className={source == 'modal' ? 'form-element' : null}>
                                    <FileUpload
                                        label={obj.name}
                                        id={obj.key}
                                        buttonName={obj.buttonName}
                                        tooltiptext={obj.tooltiptext}
                                        multiUpload={false}
                                        maxSize={obj.maxSize}
                                        acceptedFiles= {obj.supportedFiles}
                                        action={obj.iconName}
                                        defaultValue={formFields && formFields[obj.key] ? formFields[obj.key] : null}
                                        disabled={source?.includes('edit') ? true : false}
                                        onUpload={(value) => handleChange(value, obj.key)}
                                        required={obj.required}/>
                                </div>
                            )
                        }
                        if (obj.field == 'radio') {
                            return (
                                <div key={obj.key} className={source == 'modal' ? 'form-element' : null}>
                                    <RadioButton name={obj.name}
                                        label = {obj.name}
                                        options={Array.isArray(obj.optionList) ? obj.optionList : dropDownData[obj.optionList]}
                                        type={obj.id}
                                        action={obj.action ? obj.action : null}
                                        tooltiptext={obj.tooltiptext}
                                        required={obj.required}
                                        disabled={source?.includes('create') ? obj.disabled : source?.includes('edit') ? !obj.editable : source?.includes('view') ? true : false}
                                        error={formErrors && formErrors[obj.key] ? formErrors[obj.key] : null}
                                        defaultselected={formFields && formFields[obj.key] ? formFields[obj.key] : obj.defaultSelected ? obj.defaultSelected : null}
                                        onChange={(value) => handleChange(value, obj.key)}
                                        handleCheckBoxSelect={handleCheckBoxSelect}
                                    />
                                </div>
                            )
                        }
                        if (obj.field == 'checkbox') {
                            return (
                                <div key={obj.key} className={source == 'modal' ? 'form-element' : null}>
                                    <CheckBox name={obj.name}
                                        label = {obj.name}
                                        multiselect={true}
                                        options={obj.optionList}
                                        type={obj.key}
                                        action={obj.action ? obj.action : null}
                                        tooltiptext={obj.tooltiptext}
                                        required={obj.required}
                                        error={formErrors && formErrors[obj.key] ? formErrors[obj.key] : null}
                                        defaultselected={obj.label}
                                        onChange={(value) => handleChange(value, obj.key)}
                                        handleCheckBoxSelect={handleCheckBoxSelect}
                                    />
                                </div>
                            )
                        }
                        if (obj.field == 'toggleBtn') {
                            return (
                                <div key={obj.key} className={source == 'modal' ? 'form-element' : null}>
                                    <ToggleButton 
                                        left={obj.toggleFields[0]} 
                                        right={obj.toggleFields[1]} 
                                        required={obj.required}
                                        action={obj.action ? obj.action : null}
                                        tooltiptext={obj.tooltiptext}
                                        defaultSelected={formFields && formFields[obj.key] ? formFields[obj.key] : obj.defaultSelected ? obj.defaultSelected : obj.toggleFields[0]}
                                        disabled={source?.includes('edit') && obj.disableOnEdit}
                                        activatedDeactivatedSelection={obj.activatedDeactivatedSelection}
                                        error={formErrors && formErrors[obj.key] ? formErrors[obj.key] : null}
                                        selectedToggleChange={(value) => handleChange(value, obj.key)} 
                                    />
                                </div>
                            )
                        }
                        if(obj.field == 'table'){
                            return (
                                <div key={obj.key} className={source == 'modal' ? 'form-element' : null} style={{display: 'inline-table'}}>
                                    <div style={{fontSize: '14px', fontWeight: 'bold', margin: '5px 0'}}>{obj.name}</div>
                                    <div className='tableContainer' style={{marginBottom: '10px'}}>
                                        <Table columns={obj.tableHeaders} body={formFields && formFields[obj.key] ? formFields[obj.key] : []} onDelete={(val) => handleChange(val, obj.key)} source={obj.key} page='modalTable'/>
                                    </div>
                                </div>
                            )
                        }
                    })
                }
            </div>

        </div>
    )
}
export default DisplayContent;